import React, { useEffect, useState } from 'react';

const CustomDropDown = ({ title, id, className, children }: any) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = (id: any) => {
        if (document?.querySelector(`.${id}.active`)) {
            setIsOpen(false);
            document?.querySelector(`.${id}.active`)?.classList?.remove('active')
        }
        else {
            const val = document?.querySelectorAll('.topFilter .dropdown');
            if (val?.length > 0) {
                val?.forEach(dropdown => {
                    dropdown?.classList?.remove('active');
                });
            }
            const val2 = document?.querySelectorAll('.mainFilter .dropdown');
            if (val2?.length > 0) {
                val2?.forEach(dropdown => {
                    dropdown?.classList?.remove('active');
                });
            }
            setIsOpen(id);
            document.querySelector(`.${id}`)?.classList?.add('active')
        }
    };

    const handleOutsideClick = (e: any) => {
        const val = document?.querySelector(`.topFilter`);
        if (!val?.contains(e?.target)) {
            const val = document?.querySelectorAll('.topFilter .dropdown');
            if (val?.length > 0) {
                val?.forEach(dropdown => {
                    dropdown?.classList?.remove('active');
                });
            }
        }
        const val2 = document?.querySelector(`.mainFilter .dropdown`);
        if (!val2?.contains(e?.target)) {
            const val2 = document?.querySelectorAll('.mainFilter .dropdown');
            if (val2?.length > 0) {
                val2?.forEach(dropdown => {
                    dropdown?.classList?.remove('active');
                });
            }
        }
    };

    // Adding event listener for closing dropdown when clicking outside
    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    return (
        <>
            <div className={`dropdown ${className} ${id === isOpen ? 'active' : ''}`}>
                <button type="button" className="btn" onClick={() => toggleDropdown(className)}>
                    <span>{title}</span>&nbsp; <i className="fa fa-angle-down"></i>
                </button>
                <div className="dropdownBox">
                    <ul>
                        {children}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default CustomDropDown